import { render } from "./x7_cta.vue?vue&type=template&id=7f77e78b&scoped=true"
import script from "./x7_cta.vue?vue&type=script&lang=js"
export * from "./x7_cta.vue?vue&type=script&lang=js"

import "./x7_cta.vue?vue&type=style&index=0&id=7f77e78b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f77e78b"]])

export default __exports__